<template>
	<!-- Tracking -->
	<div class="pc-tracking pc-box box">
		<div class="box__title"><span class="box__icon icon icon-tracking-orange"></span>{{ title }}</div>
		<div class="box__content">
			<!-- Facebook Pixel -->
			<div class="mb-5">
				<p><b>Facebook Pixel</b></p>
				<!-- Pixel IDs -->
				<div class="form-group">
					<label>Pixel IDs</label>
					<div class="selected-options" v-if="selectedPixelIds.length > 0">
						<div class="selected-option" v-for="(pixelId, index) in selectedPixelIds" :key="index">
							<span>{{ pixelId }}</span>
							<i class="material-icons selected-option-remove" v-tooltip="'Remove'" @click="removePixelId(index)">close</i>
						</div>
					</div>
					<multiselect
						placeholder="Input or Select Pixel ID"
						:options="unselectedPixelIds"
						:hide-selected="true"
						:multiple="true"
						:taggable="true"
						:reset-after="true"
						:show-labels="false"
						tag-placeholder="Press enter to insert Pixel ID"
						@tag="addPixelId"
						@select="addPixelId">
					</multiselect>
				</div>
				<!-- Pixel Events -->
				<div class="form-group">
					<label>Pixel Events</label>
					<div class="selected-options" v-if="selectedPixelEvents.length > 0">
						<div class="selected-option flex-center justify-content-between" v-for="(pixelEvent, index) in selectedPixelEvents" :key="index">
							<span>{{ pixelEvent }}</span>
							<i
								class="material-icons selected-option-action ml-a mr-2"
								v-tooltip="'Parameters Config'"
								@click="showConfig(pixelEvent)"
								v-if="configurable">settings</i>
							<i
								class="material-icons selected-option-action selected-option-remove"
								v-tooltip="'Remove'"
								@click="removePixelEvent(index)">close</i>
						</div>
					</div>
					<multiselect
						placeholder="Input or Select Pixel Event"
						:options="unselectedPixelEvents"
						:hide-selected="true"
						:multiple="true"
						:taggable="true"
						:reset-after="true"
						:show-labels="false"
						tag-placeholder="Press enter to insert Pixel Event"
						@tag="addPixelEvent"
						@select="addPixelEvent"
					>
					</multiselect>
				</div>
			</div>

			<!-- Google Tag Manager -->
			<div class="mb-5">
				<p><b>Google Tag Manager</b></p>
				<div class="form-group">
					<label>GTM IDs</label>
					<div class="selected-options" v-if="selectedGtmIds.length > 0">
						<div class="selected-option" v-for="(gtmId, index) in selectedGtmIds" :key="index">
							<span>{{ gtmId }}</span>
							<i class="material-icons selected-option-remove" v-tooltip="'Remove'" @click="removeGtmId(index)">close</i>
						</div>
					</div>
					<multiselect
						placeholder="Input or Select GTM ID"
						:options="unselectedGtmIds"
						:hide-selected="true"
						:multiple="true"
						:taggable="true"
						:reset-after="true"
						:show-labels="false"
						tag-placeholder="Press enter to insert GTM ID"
						@tag="addGtmId"
						@select="addGtmId"
					>
					</multiselect>
				</div>
			</div>

			<!-- TikTok Pixel -->
			<div class="">
				<p><b>TikTok Pixel</b></p>
				<div class="form-group">
					<label>TikTok Pixel IDs</label>
					<div
						class="selected-options"
						v-if="selectedTiktokPixelIds.length > 0">
						<div
							class="selected-option"
							v-for="(tiktokPixelId, index) in selectedTiktokPixelIds"
							:key="index">
							<span>{{ tiktokPixelId }}</span>
							<i
								class="material-icons selected-option-remove"
								v-tooltip="'Remove'"
								@click="removeTiktokId(index)">close</i>
						</div>
					</div>
					<multiselect
						placeholder="Input or Select TikTok Pixel ID"
						:options="unselectedTiktokPixelIds"
						:hide-selected="true"
						:multiple="true"
						:taggable="true"
						:reset-after="true"
						:show-labels="false"
						tag-placeholder="Press enter to insert TikTok Pixel ID"
						@tag="addTiktokPixelId"
						@select="addTiktokPixelId"
					>
					</multiselect>
				</div>
			</div>
		</div>

		<!-- Modals -->
		<div class="modals">
			<!-- Pixel Settings -->
			<modal
				class="pixel-settings-modal"
				size="medium"
				@close="isShowConfig = false"
				v-if="isShowConfig">
				<div slot="header">
					<h3>Pixel Event Settings</h3>
				</div>
				<div slot="body">
					<h5 class="mb-4">Event: {{ selectedPixel.name }}</h5>
					<div
						class="row"
						v-for="(pixelKey, index) in selectedPixelKeys"
						:key="index">
						<!-- Key -->
						<div class="col-md-5">
							<div class="form-group">
								<!-- <label><b>Param</b></label> -->
								<input type="text" class="form-control" :value="pixelKey" readonly>
							</div>
						</div>
						<!-- Value -->
						<div class="col-md-6">
							<div class="form-group">
								<!-- <label><b>Value</b></label> -->
								<input
									type="text"
									class="form-control"
									placeholder="Param Value"
									v-model="selectedPixel[pixelKey]"
									v-if="pixelKey === 'currency' || type === 'page'"
								>
								<multiselect
									placeholder="Param Value"
									:options="pixelValueTokens"
									:multiple="false"
									:taggable="true"
									:reset-after="false"
									:show-labels="false"
									tag-placeholder="Press enter to set value"
									v-model="selectedPixel[pixelKey]"
									@tag="addValue(pixelKey, ...arguments)"
									v-else>
								</multiselect>
							</div>
						</div>
						<div class="col-md-1 p-0">
							<button type="button" class="btn btn-plain" @click="removeParam(pixelKey)">
								<i class="material-icons">close</i>
							</button>
						</div>
					</div>
					<div class="row">
						<div class="col-12">
							<label>Add More Parameter</label>
							<multiselect
								class="form-control"
								placeholder="Select or type to add new param"
								:options="pixelEventKeys"
								:show-labels="false"
								:taggable="true"
								@select="onPixelParamSelected"
								@tag="addCustomParam">
							</multiselect>
						</div>
					</div>
				</div>
				<div slot="footer">
					<button class="btn btn-default" @click="isShowConfig = false">Cancel</button>
					<button class="btn btn-primary" @click="saveConfig">{{ $t('Save') }}</button>
				</div>
			</modal>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import Modal from './Modal.vue';
import {
	pixelEventKeys,
	pixelValueTokens,
	defaultPixelConfig,
} from '@/lib/statics';
import { duplicateVar } from '@/lib/helper';
import usersApi from '@/api/user';

export default {
	name: 'box-tracking',
	props: {
		title: {
			type: String,
			default: 'Tracking',
		},
		pixelIds: {},
		pixelEvents: {},
		selectedPixelIds: {},
		selectedPixelEvents: {},
		gtmIds: {},
		selectedGtmIds: {},
		pixelConfigs: {
			type: Array,
			default: () => [],
		},
		configurable: {
			type: Boolean,
			default: true,
		},
		tiktokPixelIds: {
			type: Array,
			default: () => [],
		},
		selectedTiktokPixelIds: {
			type: Array,
			default: () => [],
		},
		type: {
			type: String,
			default: 'form',
		},
		useDefault: {
			type: Boolean,
			default: true,
		},
	},
	components: {
		Modal,
	},
	data() {
		return {
			pixelEventKeys,
			pixelValueTokens,
			selectedPixelName: null,
			selectedPixel: null,
			isShowConfig: false,
		};
	},
	methods: {
		addPixelId(value) {
			value = value.trim();
			this.selectedPixelIds.push(value);

			// Update Pixel ID
			const pixelIds = duplicateVar(this.pixelIds);
			if (pixelIds.indexOf(value) === -1) {
				pixelIds.push(value);
				usersApi.udpatePixelIds(pixelIds);
			}
		},
		removePixelId(index) {
			this.selectedPixelIds.splice(index, 1);
		},
		addPixelEvent(value) {
			value = value.trim();
			this.selectedPixelEvents.push(value);
			const configs = duplicateVar(this.pixelConfigs);
			const defaultPixelConfigValues = this.useDefault ? defaultPixelConfig : {};
			const defaultConfig = { name: value, ...defaultPixelConfigValues };
			configs.push(defaultConfig);
			this.$emit('update:pixelConfigs', configs);
		},
		removePixelEvent(index) {
			this.selectedPixelEvents.splice(index, 1);
		},
		addGtmId(value) {
			value = value.trim();
			this.selectedGtmIds.push(value);

			// Update GTM ID
			const gtmIds = duplicateVar(this.gtmIds);
			if (gtmIds.indexOf(value) === -1) {
				gtmIds.push(value);
				usersApi.udpateGTMIds(gtmIds);
			}
		},
		removeGtmId(index) {
			this.selectedGtmIds.splice(index, 1);
		},
		normalizeConfigs() {
			const defaultPixelConfigValues = this.useDefault ? defaultPixelConfig : {};
			const mapper = (config) => {
				const defaultConfig = { name: config.name, ...defaultPixelConfigValues };
				const newConfig = { ...defaultConfig, ...config };
				return newConfig;
			};
			const configs = this.pixelConfigs.map(mapper);
			this.$emit('update:pixelConfigs', configs);
		},
		showConfig(eventName) {
			const pixelConfig = this.pixelConfigs.find(({ name }) => name === eventName);
			if (pixelConfig) {
				this.selectedPixel = pixelConfig;
			} else if (this.useDefault) {
				this.selectedPixel = defaultPixelConfig;
			} else {
				this.selectedPixel = {};
			}
			this.isShowConfig = true;
		},
		saveConfig() {
			const pixelConfigs = duplicateVar(this.pixelConfigs);
			const index = pixelConfigs.findIndex(({ name }) => name === this.selectedPixel.name);
			if (index !== -1) {
				pixelConfigs[index] = duplicateVar(this.selectedPixel);
			}
			// if (this.useDefault) {
			// 	const index = pixelConfigs.findIndex(({ name }) => name === this.selectedPixel.name);
			// 	if (index !== -1) {
			// 		pixelConfigs[index] = duplicateVar(this.selectedPixel);
			// 	}
			// } else {
			// 	const selectedPixelKeys = Object.keys(this.selectedPixel);
			// 	for (let index = 0; index < selectedPixelKeys.length; index++) {
			// 		const pixelKey = selectedPixelKeys[index];
			// 		const pixelValue = this.selectedPixel[pixelKey];
			// 		const pixelConfig = {
			// 			pixelKey: pixelValue,
			// 		};
			// 		pixelConfigs.push(pixelConfig);
			// 	}
			// }
			this.$emit('update:pixelConfigs', pixelConfigs);
			this.isShowConfig = false;
		},
		addValue(key, value) {
			this.$set(this.selectedPixel, key, value);
		},
		onPixelParamSelected(param) {
			this.$set(this.selectedPixel, param, '');
		},
		/**
		 * @param {string} param Param
		 */
		addCustomParam(param) {
			const formattedParam = param.trim().replace(/\s+/g, '_');
			this.$set(this.selectedPixel, formattedParam, '');
		},
		removeParam(key) {
			this.$delete(this.selectedPixel, key);
		},
		addTiktokPixelId(value) {
			value = value.trim();
			this.selectedTiktokPixelIds.push(value);

			// Update
			const tiktokPixelIds = duplicateVar(this.tiktokPixelIds);
			if (tiktokPixelIds.indexOf(value) === -1) {
				tiktokPixelIds.push(value);
				// usersApi.udpateTikTokPixelIds(tiktokPixelIds);
			}
		},
		removeTiktokId(index) {
			this.selectedTiktokPixelIds.splice(index, 1);
		},
	},
	computed: {
		...mapGetters({
			isAdmin: 'isAdmin',
		}),
		unselectedPixelIds() {
			return this.pixelIds.filter(id => this.selectedPixelIds.indexOf(id) === -1);
		},
		unselectedPixelEvents() {
			return this.pixelEvents.filter(id => this.selectedPixelEvents.indexOf(id) === -1);
		},
		unselectedGtmIds() {
			return this.gtmIds.filter(id => this.selectedGtmIds.indexOf(id) === -1);
		},
		unselectedTiktokPixelIds() {
			return this.tiktokPixelIds.filter(id => this.selectedTiktokPixelIds.indexOf(id) === -1);
		},
		selectedPixelKeys() {
			const keys = this.selectedPixel ? Object.keys(this.selectedPixel) : [];
			return keys.filter(key => key !== 'name');
		},
	},
	created() {
		this.normalizeConfigs();
	},
};
</script>
